const makeHandleAmlFilterChange = (get) => (e) => {
  const select = e.target
  const amlId = select.value

  const renderedTemplates = document.querySelector(`[data-aml-id~='${amlId}']`)

  if (!renderedTemplates) {
    const url = select.options[select.selectedIndex].dataset.targetUrl

    get(url)
  }
}

export default ($dom, { get, select2 } = {}) => {
  const amlFilter = $dom[0].querySelector(
    'select[data-behavior~="aml-filterer"]'
  )

  const handleAmlFilterChange = makeHandleAmlFilterChange(get)

  if (amlFilter) {
    select2(amlFilter)

    $dom.on('change', '[data-behavior~="aml-filterer"]', handleAmlFilterChange)
  }

  return () => {
    $dom.off('change', '[data-behavior~="aml-filterer"]', handleAmlFilterChange)
  }
}
